var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"value":_vm.value,"label":_vm.label,"type":_vm.type,"rules":_vm.rules,"disabled":_vm.disabled,"outlined":"","dense":"","hide-details":_vm.hideDetails,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }